import React from "react";
import Heading from "../partials/Heading";
import Form from "./ContactForm";
import NavLink from "./ContactNavLink";
import "./Contact.scss";
import { featuredLinksSelectors, useAppSelector } from "../../store";
import { motion } from "framer-motion";
import { pageVariants } from "../../App";

type Props = {};

function Contact(props: Props) {
  const featuredLinks = useAppSelector(featuredLinksSelectors.selectAll);

  return (
    <motion.div
      className="contact-page"
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
    >
      <Heading>Contact</Heading>
      <div className="content">
        <div className="form-container">
          <Form />
        </div>
        <div className="nav-link-container">
          {featuredLinks.map((item, index) => {
            return <NavLink {...item} key={index} />;
          })}
        </div>
      </div>
    </motion.div>
  );
}
export { Contact as default };
